import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { size } from 'lodash'
import { DEFAULT_MAX_LETTER_COUNT } from '../config/defaults'

export const useSettingsValidationSchema = () => {
	const { t } = useTranslation()

	const settingsValidationSchema = yup.object({
		name: yup.string().required(t('Name is required')),
		address: yup.object({
			address: yup.string().required(t('Address is required')),
			postal_code: yup.string().required(t('Postal code is required')),
			city: yup.string().required(t('City is required'))
		}),
		legal_address: yup.object({
			address: yup.string().required(t('Legal address is required')),
			postal_code: yup.string().required(t('Legal postal code is required')),
			city: yup.string().required(t('Legal city is required'))
		}),
		country: yup.object({
			value: yup.string().required(t('Country is required'))
		}),
		legal_country: yup.object({
			value: yup.string().required(t('Legal country is required'))
		}),
		terms_of_service_url: yup.string().matches(/^(https?|ftps?):\/\/\S+$/i, {
			message: t('Must be a valid url'),
			excludeEmptyString: true
		}),
		start_reminder_sms_template: yup
			.string()
			.test(
				'wordCount',
				t('Max {{ count }} letters', { count: DEFAULT_MAX_LETTER_COUNT }),
				(value) => size(value) <= DEFAULT_MAX_LETTER_COUNT
			)
			.required(t('This field is required')),
		end_reminder_sms_template: yup
			.string()
			.test(
				'wordCount',
				t('Max {{ count }} letters', { count: DEFAULT_MAX_LETTER_COUNT }),
				(value) => size(value) <= DEFAULT_MAX_LETTER_COUNT
			)
			.required(t('This field is required')),
		enabled_payout_methods: yup
			.array()
			.of(yup.string())
			.min(1, t('Enable at least one payout method.')),
		booking_fees: yup.object({
			booth_takedown_fee: yup.string().matches(/^\d+\.?\d{0,2}$/, t('Must be a number')),
			booth_takedown_fee_notified: yup.string().matches(/^\d+\.?\d{0,2}$/, t('Must be a number')),
			product_storage_fee_per_day: yup.string().matches(/^\d+\.?\d{0,2}$/, t('Must be a number')),
			product_storage_max_days: yup.string().matches(/^[0-9]+$/, t('Must be a number'))
		})
	})

	return yupResolver(settingsValidationSchema)
}
